import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../app.constant';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private frappe: FrappeApp;
  private frappeCall: FrappeCall;
  constructor() {
    this.frappe = new FrappeApp(AppConstant.frappeUrl);
    this.frappeCall=this.frappe.call()
  }


  public getPoByDate(date:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_po_by_date',{data:JSON.stringify(date)})
  }

  public getGrByDate(date:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_gr_by_date',{data:JSON.stringify(date)})
  }

  public getShipmentAsnByDate(date:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_shipment_asn_by_date',{data:JSON.stringify(date)})
  }

  public getScheduleByDate(date:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_schedule_by_date',{data:JSON.stringify(date)})
  }

  public getIrByDate(date:any): Promise<any> {
    return this.frappeCall.get('vendor_portal.rest.get_ir_by_date',{data:JSON.stringify(date)})
  }
}
